import { render, staticRenderFns } from "./PackageForm.vue?vue&type=template&id=f25a0958&scoped=true&"
import script from "./PackageForm.vue?vue&type=script&lang=js&"
export * from "./PackageForm.vue?vue&type=script&lang=js&"
import style0 from "./PackageForm.vue?vue&type=style&index=0&id=f25a0958&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f25a0958",
  null
  
)

export default component.exports